<template>
  <form>
    <ul>
      <li class="facet OTfacet" v-for="dimension in facet.dimensions" :key="dimension.id">
        <!-- from to -->
        <div class="fieldContainer form-group OTformgroupsingle" v-if="dimension.id === 'FT_ID'">
          <input
            type="radio"
            class="OTradio"
            :id="'facet-' + slugify(dimension.id)"
            :name="facet.id"
            :value="dimension.id"
            v-on:click="selectFacet(dimension)"
            :checked="isSelected(dimension.id)"
          />
          <label class="OTradio OTradioCalendar" :for="'facet-' + slugify(dimension.id)">
            <span class="OTicon-radio" />
            <b-row class="OTradio no-gutters"  style="padding-left:0.25rem;margin-top:0.25rem">
              <b-col cols="12">
                From:
                <FromToDateAndTime v-model="fromDate"></FromToDateAndTime>
              </b-col>
              <b-col cols="12"   style="margin-top:0.25rem">
                To:
                <FromToDateAndTime v-model="toDate"></FromToDateAndTime>
              </b-col>
            </b-row>
            <div
              class="OTchiclet float-right"
              v-if="showChicklet(dimension.id)"
            >{{ getDimensionCount(dimension.id) }}</div>
          </label>
        </div>
        <!-- from to end -->
        <div class="fieldContainer form-group OTformgroupsingle" v-else>
          <input
            type="radio"
            class="OTradio"
            :id="'facet-' + slugify(dimension.id)"
            :name="facet.id"
            :value="dimension.id"
            v-on:click="selectFacet(dimension)"
            :checked="isSelected(dimension.id)"
          />
          <label class="OTradio" :for="'facet-' + slugify(dimension.id)">
            <span class="OTicon-radio" />
            {{ dimension.label }} &nbsp;
            <div
              class="OTchiclet float-right"
              v-if="showChicklet(dimension.id)"
            >{{ getDimensionCount(dimension.id) }}</div>
          </label>
        </div>
      </li>
    </ul>
  </form>
</template>
<script>
import { slugify } from "../../utils.js";
import moment from "moment";
import FromToDateAndTime from "./FromToFilterDateAndTime.vue";

import axios from "axios";

export default {
  data() {
    return {
      datePickerOptions: {
        format: "YYYY-MM-DD",
        keepInvalid: true,
        inline: true
        //inline: true
      },
      fromDate: String,
      toDate: String
    };
  },
  props: ["facet", "value"],
  components: {
    FromToDateAndTime
  },
  methods: {
    async selectFacet(dimension) {
      if (dimension.id === "FT_ID") {
        var fromDateinMillis = new Date(this.fromDate).getTime();
        var toDateinMillis = new Date(this.toDate).getTime();
        // if (!isNaN(fromDateinMillis) && !isNaN(toDateinMillis)) {
        //   this.$emit("input", {dimensions:[dimension.id], fromDateinMillis:fromDateinMillis, toDateinMillis:toDateinMillis});
        // }
        if (!isNaN(fromDateinMillis)) {
          if (!isNaN(toDateinMillis)) {
            this.$emit("input", {
              dimensions: [dimension.id],
              fromDateinMillis: fromDateinMillis,
              toDateinMillis: toDateinMillis
            });
          } else {
            this.$emit("input", {
              dimensions: [dimension.id],
              fromDateinMillis: fromDateinMillis
            });
          }
        } else {
          if (!isNaN(toDateinMillis)) {
            this.$emit("input", {
              dimensions: [dimension.id],
              toDateinMillis: toDateinMillis
            });
          } else {
            // NO nothing
          }
        }
        this.valueChanged = false;
      } else {
        this.$emit("input", { dimensions: [dimension.id] });
      }
    },
    slugify(val) {
      return slugify(val);
    },
    showChicklet(dimensionId) {
      var dimension = this.$store.state.facets.facets[
        this.facet.id
      ].dimensions.find(d => d.id === dimensionId);
      return dimension.count > 0;
    },
    getDimensionCount(dimensionId) {
      var dimension = this.$store.state.facets.facets[
        this.facet.id
      ].dimensions.find(d => d.id === dimensionId);
      return dimension.count;
    },
    isSelected(dimensionId) {
      if (!this.$store.state.facets.selectedFacets[this.facet.id]) {
        return false;
      }

      for (
        let i = 0;
        i < this.$store.state.facets.selectedFacets[this.facet.id].length;
        i++
      ) {
        if (
          this.$store.state.facets.selectedFacets[this.facet.id][i] ===
          dimensionId
        ) {
          return true;
        }
      }
      return false;
    }
  },
  computed: {
    selectedFacets() {
      return this.$store.state.facets.selectedFacets;
    }
  },
  watch: {
    fromDate(newValue) {
      this.selectFacet(
        this.$store.state.facets.facets[this.facet.id].dimensions.find(
          d => d.id === "FT_ID"
        )
      );
    },
    toDate(newValue) {
      this.selectFacet(
        this.$store.state.facets.facets[this.facet.id].dimensions.find(
          d => d.id === "FT_ID"
        )
      );
    }
  }
};
</script>

